import { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';

export default function Page() {
  // Scroll to top when the privacy paVjjge loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <header className="mb-8">
          <a href="/">
            <a className="text-primary hover:text-primary/80 flex items-center mb-8">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Calculator
            </a>
          </a>
          <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-2">Privacy Policy</h1>
          <p className="text-muted-foreground">Last updated: April 13, 2025</p>
        </header>

        <main className="prose prose-lg dark:prose-invert">
          <section className="mb-8">
            <h2>Overview</h2>
            <p>
              At MyTaxPal, we take your privacy seriously. This Privacy Policy explains what information we collect, 
              how we use it, and the choices you have regarding your information.
            </p>
          </section>

          <section className="mb-8">
            <h2>Information We Collect</h2>
            <p>
              <strong>Local Storage Data:</strong> We store your calculator preferences and saved scenarios in your browser's local storage.
              This data never leaves your device and is not transmitted to our servers.
            </p>
            <p>
              <strong>No Personal Information:</strong> MyTaxPal does not collect, store, or transmit any personally identifiable information.
              All calculations are performed locally in your browser.
            </p>
          </section>

          <section className="mb-8">
            <h2>How We Use Information</h2>
            <p>
              The only data we store is in your browser's local storage, which is used exclusively to:
            </p>
            <ul>
              <li>Remember your calculator settings</li>
              <li>Save scenarios you've created for future reference</li>
              <li>Provide a better user experience by not requiring you to re-enter information</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2>Analytics</h2>
            <p>
              We use anonymous, aggregate analytics to understand how users interact with our website. This helps us improve 
              the user experience and fix issues. Our analytics do not track individual users or collect personally 
              identifiable information.
            </p>
          </section>

          <section className="mb-8">
            <h2>Third Party Services</h2>
            <p>
              We do not share any information with third parties.
            </p>
          </section>

          <section className="mb-8">
            <h2>Security</h2>
            <p>
              Since we don't collect personal data on our servers, there is minimal risk to your privacy. 
              Your local storage data is subject to the security of your browser and device.
            </p>
          </section>

          <section className="mb-8">
            <h2>Changes to This Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting 
              the new Privacy Policy on this page and updating the "Last updated" date.
            </p>
          </section>

          <section className="mb-8">
            <h2>Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at privacy@mytaxpal.com.au.
            </p>
          </section>
        </main>

        <footer className="mt-16 pt-8 border-t border-border text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} MyTaxPal. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};